require("./snippets/accordion");
require("./snippets/v3-accordion");
require("./qf/tracking");
require("./snippets/product-quick-view-modal");
require("./qf/global_listeners");
//require("./qf/wishlistAsObject");
require("./qf/cart");
require("./qf/loadMore");
require("./qf/ModalController");
require("./qf/babCart");

window.modalController = new ModalController()
// window.wishlist = new WishlistObjectQf();
window.globalListeners = new GlobalListeners();
window.cart = new CartQf();
window.babCart = new babCart()
